<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="8">
        <OperatorList
          :operators="operators"
          :companies="companies"
          :filters="filters"
          :groupsMap="groupsMap"
          :groups="groups"
          :cifsMap="cifsMap"
          :externalsAuths="externalsAuths"
          :loading="loading"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import OperatorList from '@/components/operators/OperatorList'
import { getCifs } from '@/services/cifs-service'
import { listFilters } from '@/services/filter-service'
import {
  getOperatorsSubscriptionCRUD,
  clearOperatorsHeavyCache,
  clearManageOperatorsCache,
} from '@/services/operator-service'
import { getGroups } from '../services/groups-service'
import { listExternalsAuths } from '@/services/externals-auths-service'

export default {
  components: {
    OperatorList,
  },
  async beforeMount() {
    const userId = this.isOperatorUser
      ? this.$store.state.user.parentRef.id
      : this.$store.state.user.id

    this.operatorsUnsubscribe = await getOperatorsSubscriptionCRUD(userId)

    await Promise.all([
      (async () => {
        this.companies = await getCifs(userId)
        this.companies.forEach((cif) => (this.cifsMap[cif.id] = cif))
      })(),
      (async () => (this.filters = await listFilters()))(),
      (async () => {
        const { groups, groupsMap } = await getGroups()
        this.groups = groups
        this.groupsMap = groupsMap
      })(),
      (async () => (this.externalsAuths = await listExternalsAuths(userId)))(),
    ])

    this.loading = false
  },
  async destroyed() {
    if (this.operatorsUnsubscribe) {
      this.operatorsUnsubscribe()
      clearOperatorsHeavyCache()
      // Limpiamos en el store
      clearManageOperatorsCache()
    }
  },
  data() {
    return {
      companies: [],
      filters: [],
      groups: [],
      groupsMap: {},
      cifsMap: {},
      externalsAuths: [],
      loading: true,
      operatorsUnsubscribe: () => {},
    }
  },
  computed: {
    ...mapGetters(['isOperatorUser']),
    operators() {
      return this.$store.state.manageOperators ?? []
    },
  },
}
</script>
